
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/katalog/[[...id]]",
      function () {
        return require("private-next-pages/katalog/[[...id]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/katalog/[[...id]]"])
      });
    }
  